import { createMutationHelper } from '@utils/swr'
import { type CreateOrderFromPdfRequest } from '../types/apiRequest'
import { type CreateOrderResponse } from '../types/apiResponse'
import { type ButlerApis } from '../types/apis'

const {
  useMutation,
} = createMutationHelper<ButlerApis['post']['createOrderFromPdf'], CreateOrderResponse, CreateOrderFromPdfRequest>({
  client: 'butler',
  key: '/orders/upload/pdf',
  fetcher: (url, { arg, client }) => {
    const formData = new FormData()
    formData.append('file', arg.file)
    formData.append('campaignId', String(arg.campaignId))
    formData.append('customerId', String(arg.customerId))
    return client.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
})

export const useCreateOrderFromPdf = useMutation
